import { Component, Injector, OnInit } from '@angular/core';
import { FeatureComponent } from '../../calculators/feature-component-registry/feature-component.interface';
import { NavigationService } from '../../../shared/services/navigation/navigation.service';
import { AppConfiguration } from '../../../bootstrap/clp/app.configuration';

@Component({
  selector: 'app-clp-home-energy',
  templateUrl: './clp-home-energy.component.html',
  styleUrls: ['../clp-calculator.component.css']
})

export class ClpHomeEnergyComponent implements OnInit, FeatureComponent {

  page:string = "home-energy";

  data: any;

  appConfiguration: AppConfiguration;

  imageUrl : any;
   
  html: any = {};

  featureComponents: any = {};

  cleanFeatureComponents : any = [];

  activeComponentGroup : any;

  constructor(private injector: Injector) { 
    this.appConfiguration = this.injector.get(AppConfiguration);
  }

  ngOnInit(): void {
    this.featureComponents = this.appConfiguration.getEnvironment().featureComponents;

    const component = this.featureComponents.find(x => x.name == this.page);
    this.html = component.html;

    this.featureComponents.forEach(featureComponent => {
      if (featureComponent.main) {
        this.cleanFeatureComponents.push(featureComponent.title);
      }
    });
    this.activeComponentGroup = component.title;
  }

  nextFeature() {
    this.injector.get(NavigationService).slideActiveTabForward();
  }

  previousFeature() {
    this.injector.get(NavigationService).slideActiveTabBack();
  }

  start(){
    this.injector.get(NavigationService).slideActiveTabStart();
  }

  isEmpty(value : any){
    return (value == "" || value == null);
  };
}
